export const PHONE_NAMES = [
  "iPhone 12",
  "iPhone 12 Pro",
  "iPhone 13",
  "iPhone 13 Pro",
];
